module.exports = __webpack_public_path__ + "static/media/axe.fe41e5a6.svg";